import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class ProductDesigner extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Recruiting / Talent Sourcer</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">

                        <SNIntro />
                        <p className="p2">
                            {`As the `}<b>Recruiting / Talent Sourcer</b>{` you will source for passive and active talent - building pipelines for a number of positions between business and technical roles. You will be an integral member of our talent acquisition function; You will be responsible for delivering top talent and act as an excellent representative on behalf of Social Native. You possess the ability to be creative and proactive in your approach for identifying top level talent.`}
                        </p>
                        <br/>

                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                {`Partner with our recruiting team in achieving hiring targets for our field leadership positions (General Managers & Assistant General Managers)`}
                            </li>
                            <li className="p3">
                                Source, identify, and build a candidate pipeline of top talent for current and future open positions through direct sourcing, social media (i.e. LinkedIn, Glassdoor, Facebook), and industry associations, alumni organizations, etc.
                            </li>
                            <li className="p3">
                                Screen resumes to ensure talent is aligned with core values and expectations of the company.
                            </li>
                            <li className="p3">
                                Contribute understanding of market and hiring trends for recruiting needs across our markets, nation-wide.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                At least 1+ years experience in recruiting.
                            </li>
                            <li className="p3">
                                Experience using ATS systems.
                            </li>
                            <li className="p3">
                                Prior experience recruiting and/or sourcing for a start-up or rapidly growing organization.
                            </li>
                            <li className="p3">
                                Online Job Board, Social Site, and tech savvy.
                            </li>
                            <li className="p3">
                                Keen eye for detail.
                            </li>
                            <li className="p3">
                                Strong organizational skills.
                            </li>
                            <li className="p3">
                                Driven by targets and deadlines.
                            </li>
                            <li className="p3">
                                Manages time effectively with multiple projects.
                            </li>
                            <li className="p3">
                                Knack for recruiting and scouting top talent.
                            </li>
                            <li className="p3">
                                Takes initiative and can work independently.
                            </li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/talent_sourcer.js